import React from 'react';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';
import { SHORT_BOOLEAN_LABEL_LIMIT } from 'components/show_drawing/redraw_form/options/renderOption.jsx';

// Admin-only toggle for showing/hiding the bounding-box (overall part width/height)
// dimensions. Unlike the "Dimension lines" checkbox next to it — which only shows/hides
// on the client — this drives a server-side redraw: its value rides the redraw request
// (see ShowDrawing#GetRequestPath) and toggling it requests a fresh redraw. The value is
// read straight from state rather than the checkbox field, because an unchecked checkbox
// is dropped from the form data and would read as "shown" instead of "hidden".
const BoundingBoxDimensionTextsIncludedChooser = ({ boundingBoxDimensionTextsIncluded, setBoundingBoxDimensionTextsIncluded, setRedrawRequested }) => {
  const toggle = () => {
    setBoundingBoxDimensionTextsIncluded((prev) => !prev);
    setRedrawRequested(() => true);
  };

  const label = t('models.bounding_box_dimension_texts');
  const widthClass = label.length <= SHORT_BOOLEAN_LABEL_LIMIT ? '' : styles.booleanGridItemWide;

  return (
    <div className={`${styles.row} ${widthClass}`}>
      <div className="input-group short-text">
        <span
          className={`${styles.clickable} input-group-addon input-group-addon-${window.locale} ${styles.input_add_on_for_boolean} ${styles.boolean_inline_row}`}
          onClick={toggle}
        >
          <div className={styles.div_boolean}>
            <input
              type="checkbox"
              className="drawing-option-input"
              checked={boundingBoxDimensionTextsIncluded}
              readOnly
              autoComplete="off"
            />
          </div>
          { label }
        </span>
      </div>
    </div>
  );
};

export default BoundingBoxDimensionTextsIncludedChooser;
